import { Modal } from '../../../components/common/Modal';
import { useLanguage } from '../../../features/language/useLanguage';
import type { Recipe } from '../../../types/recipe';

interface DeleteRecipeModalProps {
  recipe: Recipe | null;
  error: string | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation dialog for deleting a recipe. Dedicated (not the shared
 * ConfirmationDialog) because it stays open showing a deleting state and an
 * inline error while the mutation runs.
 */
export function DeleteRecipeModal({ recipe, error, isDeleting, onClose, onConfirm }: DeleteRecipeModalProps) {
  const { t } = useLanguage();
  return (
    <Modal isOpen={Boolean(recipe)} onClose={onClose} title={t('greenBeanProfile.deleteModal.title')} maxWidth="md">
      <div className="space-y-4">
        <p className="text-sm text-gray-700">
          {t('recipes.page.confirmDeletePrefix')} <span className="font-semibold">{recipe?.name}</span>?
        </p>
        {error && <div className="rounded-md bg-red-50 p-3 text-sm text-red-700">{error}</div>}
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isDeleting}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed"
          >
            {t('auth.common.cancel')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {isDeleting ? t('recipes.page.actions.deleting') : t('purchasing.supplierList.actions.delete')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
